import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { Card, CardHeader, Collapse } from 'reactstrap';

const column1 = [
  {
    Header: 'Categories',
    accessor: 'CATEGORY',
    width: 500,
  },

  {
    Header: 'Results',
    accessor: 'RESULTS',
    style: { whiteSpace: 'unset' },
  },
];

const fixMisspelling = data => {
  data = data
    .map(obj => {
      if (obj.CATEGORY === 'Bisiness Classification') {
        obj.CATEGORY = 'Business Classification';
      }
      if (obj.RESULTS === 'true') {
        obj.RESULTS = 'Yes';
      }
      if (obj.RESULTS === 'false') {
        obj.RESULTS = 'No';
      }

      return obj;
    })
    .filter(obj => obj.CATEGORY !== 'ICON_Member' && obj.RESULTS !== '');
  return data;
};

const Header = data => {
  const [toggleQuestion, setToggequestion] = useState(1);
  return (
    <div className="nf-u-details__grid">
      <Card className="nf-solicitation-detail__card">
        <CardHeader
          className="nf-solicitation-detail__card-header"
          onClick={() => setToggequestion(!toggleQuestion)}
        >
          <p>Supplier Capabilities</p>
          {toggleQuestion ? <UpOutlined /> : <DownOutlined />}
        </CardHeader>

        <Collapse isOpen={toggleQuestion}>
          <ReactTable
            data={fixMisspelling(data.block)}
            columns={column1}
            defaultPageSize={
              data.block.length > 0 ? fixMisspelling(data.block).length : 3
            }
            style={{ textAlign: 'left' }}
            showPagination={false}
          />
        </Collapse>
      </Card>

      {/* <Table dataSource={drawings} columns={columns} /> */}
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/CageDetailsTables/SupplierCaps.jsx